import client from '/src/services/client.js';
// Endpoint api blocks
export default {
    createBlock : (bot_id, data) => client.post(`bot/${bot_id}/block`, data),
    getBlockInformations : (name) => client.get(`bot/block/information/${name}`),
    updateBlockName : (bot_id, id, name) => client.put(`bot/${bot_id}/block/${id}`, { name }),
    updateBlockPosition : (bot_id, id, x, y) => client.put(`bot/${bot_id}/block/${id}`, {x, y}),
    updateBlocksPosition : (bot_id, blocks) => client.put(`bot/${bot_id}/blocks/position`, { blocks }),
    updateBlocksName : (bot_id, blocks) => client.put(`bot/${bot_id}/blocks/name`, { blocks }),
    updateBlockData : (bot_id, id, data) => client.put(`bot/${bot_id}/block/${id}`, { ...data }),
    updateBlockHaveStatistic : (bot_id, id, is_statistic = false) => client.put(`bot/${bot_id}/block/${id}`, { is_statistic }),
    deleteBlock : (bot_id, id) => client.delete(`bot/${bot_id}/block/${id}`),
}